import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import Layout from 'shared/layout/Layout/ui/Layout'
import { uiStore } from 'shared/store/uiStore'
import { initCanny } from 'entities/Canny'
import { eventHeartbeat } from 'entities/DataLog/events/EventHeartbeatLog'
import { initIntercom } from 'entities/Intercom'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AuthPath } from 'pages/auth/route/authPath'
import { getAppData } from 'app/shared/lib'
import { SidebarLayout } from './SidebarLayout'

type AuthLayoutProps = {
  withoutSidebar?: boolean
}

export const AuthLayout = observer(({ withoutSidebar }: AuthLayoutProps) => {
  const entities = useEntitiesContext()
  const { mergeFieldStore, authStore } = entities

  useEffect(() => {
    if (!authStore.isRefresh) return
    if (!authStore.isLoggedIn) {
      uiStore.changeRoute({
        path: `/${AuthPath.login}`,
      })
    } else {
      getAppData(entities).finally(() => {
        entities.complianceStore.initComplianceUKModal()
      })
      entities.callStore.initDevice()
      initCanny(entities)
      initIntercom({
        fromAuthorizedApp: true,
        entities: entities,
      })
      entities.numbersStore.initStartNumberModal()
      entities.numbersStore.initConnectTwilioModal()
      entities.remindersStore.init()
      mergeFieldStore.loadAllFields()
      authStore.resetLoggedIn()

      eventHeartbeat(entities)
    }
  }, [authStore.isLoggedIn, authStore.isRefresh])

  if (withoutSidebar) {
    return <Layout />
  }

  return <SidebarLayout />
})
